import { useState } from 'react';
import { useTTSStore } from '../../store/tts';
import { ttsService } from '../../services/tts';
import toast from 'react-hot-toast';

function HistoryList() {
  const { history, historyTotal, isLoadingHistory, deleteFromHistory } = useTTSStore();
  const [loadingId, setLoadingId] = useState(null);

  const handlePlay = async (item) => {
    setLoadingId(item.id);
    try {
      const audioUrl = await ttsService.getAudioBlob(item.id);
      const audio = new Audio(audioUrl);
      audio.play();
    } catch (error) {
      toast.error('Failed to play audio');
    } finally {
      setLoadingId(null);
    }
  };

  const handleDownload = async (item) => {
    setLoadingId(item.id);
    try {
      const audioUrl = await ttsService.getAudioBlob(item.id);
      const a = document.createElement('a');
      a.href = audioUrl;
      a.download = `speech_${item.id}.wav`;
      a.click();
    } catch (error) {
      toast.error('Failed to download audio');
    } finally {
      setLoadingId(null);
    }
  };

  const handleDelete = async (item) => {
    if (!confirm('Delete this audio?')) return;
    const result = await deleteFromHistory(item.id);
    if (result.success) {
      toast.success('Audio deleted');
    } else {
      toast.error('Failed to delete');
    }
  };

  if (isLoadingHistory) {
    return (
      <div className="card">
        <h3 className="font-semibold mb-4">Recent Conversions</h3>
        <div className="flex justify-center py-8">
          <span className="spinner w-6 h-6"></span>
        </div>
      </div>
    );
  }

  if (history.length === 0) {
    return (
      <div className="card">
        <h3 className="font-semibold mb-4">Recent Conversions</h3>
        <p className="text-gray-400 text-center py-4">No conversions yet</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold">Recent Conversions</h3>
        <span className="text-sm text-gray-400">{historyTotal} total</span>
      </div>
      
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {history.map((item) => (
          <div
            key={item.id}
            className="bg-gray-700/50 rounded-lg p-3 hover:bg-gray-700 transition-colors"
          >
            <p className="text-sm text-gray-300 truncate mb-2" title={item.text}>
              {item.text.substring(0, 80)}{item.text.length > 80 ? '...' : ''}
            </p>
            
            <div className="flex items-center justify-between">
              <div className="flex flex-wrap items-center gap-2 text-xs text-gray-400">
                <span className="bg-purple-600/30 text-purple-300 px-2 py-0.5 rounded">
                  {item.voice_name || item.voice_id}
                </span>
                <span className="bg-blue-600/30 text-blue-300 px-2 py-0.5 rounded">
                  {item.language_name || item.language}
                </span>
                <span>{item.character_count} chars</span>
                {item.audio_duration && (
                  <span>{item.audio_duration.toFixed(1)}s</span>
                )}
                <span>{new Date(item.created_at).toLocaleDateString()}</span>
              </div>
              
              <div className="flex items-center space-x-2">
                <button
                  onClick={() => handlePlay(item)}
                  className="p-1.5 hover:bg-gray-600 rounded text-gray-400 hover:text-white disabled:opacity-50"
                  title="Play"
                  disabled={loadingId === item.id}
                >
                  {loadingId === item.id ? '⏳' : '▶️'}
                </button>
                <button
                  onClick={() => handleDownload(item)}
                  className="p-1.5 hover:bg-gray-600 rounded text-gray-400 hover:text-white disabled:opacity-50"
                  title="Download"
                  disabled={loadingId === item.id}
                >
                  ⬇️
                </button>
                <button
                  onClick={() => handleDelete(item)}
                  className="p-1.5 hover:bg-gray-600 rounded text-gray-400 hover:text-red-400"
                  title="Delete"
                >
                  🗑️
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default HistoryList;
